import styled from 'styled-components'

export const FacilityItemText = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 16px;
  line-height: 19px;
`

export const FacilityItemDescription = styled.p<{ balance?: boolean }>`
  margin: 0;
  color: ${({ theme, balance }) =>
    balance ? theme.colors.secondary : '#3e4954'};
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
`
